import {
    GET_CONFIG_FORM,
    GET_COMBO_RECEPCIONAR,
    GET_RESPONSABLE_PREASIGNADO,
    GET_CMB_TIPO_GESTION,
    POST_RECEPCIONAR
} from '../types';


export default function gestionCasoReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM:
            return { ...state, ...action.payload }
        case GET_COMBO_RECEPCIONAR:
            return { ...state, comboRecepcionar: action.payload }
        case GET_RESPONSABLE_PREASIGNADO:
            return { ...state, ...action.payload }
        case GET_CMB_TIPO_GESTION:
            return { ...state, comboTipoGestion: action.payload }
        case POST_RECEPCIONAR:
            return { ...state, ...action.payload }
      
     
        default:
            return state
    }
}